<template>
  <div class="product-card" @click="$emit('click')">
    <img :src="product.coverImage" alt="" />
    <h3>{{ product.title }}</h3>
<!--    <p>{{ product.description }}</p>-->
    <!-- 底部信息 -->
    <div class="card-footer">
      <span class="views">👁 {{ product.viewCount || 0 }}</span>
      <span class="price">
        ￥{{ product.price }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: { type: Object, required: true }
  },
  data() {
    return { }
  },
  methods: {

  }
}
</script>

<style scoped>
.product-card {
  cursor: pointer;
  text-align: center;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s;

  display: flex;
  flex-direction: column;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-card img {
  width: 100%;
  border-bottom: 1px solid #eee;
}

.product-card h3 {
  font-size: 18px;
  margin: 10px 0 5px;

  height: 48px;             /* ⭐ 标题高度固定 */
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  font-size: 14px;
  color: #555;
  border-top: 1px solid #eee;

  margin-top: auto;         /* ⭐ 保证价格贴底对齐 */
}

.views {
  font-size: 12px;
  color: #999;
}

.price {
  font-size: 16px;
  color: #e44d26;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductCard.vue